import { ComuneDTO } from "./comuneDTO";

export class CartaceoDTO {
  dug: string;
  indirizzo: string;
  numeroCivico: string;
  comune: ComuneDTO = new ComuneDTO();
  codiceIstat: string;
  provincia: string;
  esteroCitta: string;
  esteroProvincia: string;
  cap: string;
  nazione: string;
}
